<template>
  <div>
    <h3 class="signIn-out-header">{{ $t("common.signInOut") }}</h3>

    <h3 class="signIn-out-status">
      <b>
        {{ $t("signInOut.unpermittedUsers") }}
      </b>
    </h3>

    <p class="all-paragraphs">
      {{ $tc("signInOut.userTypeModalErrMsg", 1) }}
    </p>

    <hr />

    <div class="btn-container">
      <button class="confirmation-btn" @click="onSubmit">{{ $t('common.okay')}}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      site_name: "",
      err_type: "",
    };
  },
  methods: {
    onSubmit() {
      this.$bvModal.hide("allUserType");
      this.$bvModal.hide("signinMassaction");
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  mounted() {
    const { site_name, err_type } = this.getModalInfo;
    this.site_name = site_name;
    this.err_type = err_type;
  },
};
</script>
<style lang="scss">
div#allUserType___BV_modal_content_ {
  width: 579px !important;
  margin-top: 150px;
  h3.signIn-out-header {
    color: #000;
    font-size: 17px;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 40px;
  }
  h3.signIn-out-status {
    color: #787878;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 155%;
    margin-bottom: 16px;
  }
  p.all-paragraphs {
    color: var(--939393, #939393);
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 28.5px;
    letter-spacing: 0.25px;
    margin-bottom: 0px !important;
  }
  hr {
    margin-top: 40px !important;
    margin-bottom: 20px !important;
    border: 0;
    border-top: 1px solid #707070;
    opacity: 0.15;
  }
  .btn-container {
    display: flex;
    justify-content: center;
    button.confirmation-btn {
      width: 112px;
      height: 33px;
      border-radius: 16.5px;
      background: #103f5e;
      border: none;
      color: #fff;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      line-height: normal;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
